module.exports = __webpack_public_path__ + "c8278eedb981a7884a9fb74ebd5ce083.jpg";